import { objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import ListItem from './list-item.esm.js';
import ListItemText from './list-item-text.esm.js';

var _excluded = ["primary", "secondary"];
var StandardListItem = function StandardListItem(props) {
  var primary = props.primary,
    secondary = props.secondary,
    rest = _objectWithoutProperties(props, _excluded);
  // eslint-disable-next-line no-console
  // console.log('--- render @costar/theme-ui StandardListItem -----')
  return /*#__PURE__*/React.createElement(ListItem, rest, /*#__PURE__*/React.createElement(ListItemText, {
    primary: primary,
    secondary: secondary
  }));
};
var standardListItem = /*#__PURE__*/React.memo(StandardListItem);

export default standardListItem;
//# sourceMappingURL=standard-list-item.esm.js.map
